import { IHouseInfoResponseV2Schema } from '../../repositories/price-estimator/entities/house_info/HouseInfoResponseV2Schema';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  GetHouseInfoRequest = 'houseInfo/Request',
  GetHouseInfoSuccess = 'houseInfo/Success',
  GetHouseInfoFailure = 'houseInfo/Failure',
}

export const getHouseInfoRequest = actionGenerator<EActionTypes.GetHouseInfoRequest, void>(
  EActionTypes.GetHouseInfoRequest,
);
export const getHouseInfoSuccess = actionGenerator<EActionTypes.GetHouseInfoSuccess, IHouseInfoResponseV2Schema>(
  EActionTypes.GetHouseInfoSuccess,
);
export const getHouseInfoFailure = actionGenerator<EActionTypes.GetHouseInfoFailure, void>(
  EActionTypes.GetHouseInfoFailure,
);

type TGetHouseInfoRequestAction = ReturnType<typeof getHouseInfoRequest>;
type TGetHouseInfoSuccessAction = ReturnType<typeof getHouseInfoSuccess>;
type TGetHouseInfoFailureAction = ReturnType<typeof getHouseInfoFailure>;

export type THouseInfoActions = TGetHouseInfoRequestAction | TGetHouseInfoSuccessAction | TGetHouseInfoFailureAction;
